export default angular
  .module('doxy.common.directives.scrollToBottom', [])
  .directive('dScrollToBottom', function () {
    return {
      scope: false,
      restrict: 'A',
      link(scope, element) {
        const pureElement = element[0];
        scope.$watch(
          () => pureElement.scrollHeight,
          (newValue, oldValue) => {
            pureElement.scrollTop =
              newValue !== oldValue
                ? pureElement.scrollHeight
                : pureElement.scrollTop;
          }
        );
      },
    };
  }).name;
